import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
const RandomDataWarning = ({ intl }) => (
  <Box
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '2px 0'
    }}
  >
    <InfoOutlined style={{ fontSize: 15, color: '#94a3b8', flexShrink: 0 }} />
    <Typography style={{ fontSize: '1.1rem', color: '#94a3b8' }}>
      {intl.formatMessage({ id: 'chat-gpt-ice-breaking-drawer-content-warning' })}
    </Typography>
  </Box>
);

export default RandomDataWarning;
